import { ComponentType } from 'react'

import { AccentraCard } from './accentra-card'
import { BrivoCard } from './brivo-card'
import { CredentialsCardProps } from './credentials-form-card'
import { DormakabaCard } from './dormakaba-card'
import { IglooWorkCard } from './igloo-work-card'
import { PointCentralCard } from './point-central-card'
import { SaltoSpaceCard } from './salto-space-card'
import { SwiftlaneCard } from './swiftlane-card'

export type CredentialsProvider =
  | 'accentra'
  | 'brivo'
  | 'dormakaba'
  | 'iglooWork'
  | 'pointCentral'
  | 'saltoSpace'
  | 'swiftlane'

export const PROVIDER_CARDS: Record<CredentialsProvider, ComponentType<CredentialsCardProps>> = {
  accentra: AccentraCard,
  brivo: BrivoCard,
  dormakaba: DormakabaCard,
  iglooWork: IglooWorkCard,
  pointCentral: PointCentralCard,
  saltoSpace: SaltoSpaceCard,
  swiftlane: SwiftlaneCard,
}
